import { useStytchIsAuthorized } from '@stytch/react/b2b'

export default function useIsSuperUser() {
  const { isAuthorized } = useStytchIsAuthorized('pd', 'prime')
  return isAuthorized
}
